// Color Palette for the Application

const colorPalette = {
  // Base Colors
  white: "#ffffff",
  lightGrey: "#f5f5f7",
  grey: "#e5e5e5",
  darkGrey: "#6e6e73",
  black: "#1d1d1f",

  // Accent Colors
  primary: "#0071e3", // Primary blue
  primaryDark: "#0051a8", // Darker blue for hover states
  purple: "#5e5ce6", // Purple accent

  // Status Colors
  success: "#34c759", // Green
  successDark: "#2db04e", // Darker green for hover
  warning: "#ff9500", // Orange
  warningDark: "#e68600", // Darker orange for hover
  danger: "#ff3b30", // Red
  dangerDark: "#d91b0c", // Darker red for hover
  info: "#5ac8fa", // Light blue
  infoDark: "#2c7faa", // Darker light blue for hover

  // Feature Card Colors
  lightningBg: "#fff8ee",
  lightningBorder: "#ff9500",
  thunderBg: "#eef2ff",
  thunderBorder: "#0071e3",
  rumbleBg: "#f0f7f2",
  rumbleBorder: "#34c759",
};

export default colorPalette;
